module.exports = __webpack_public_path__ + "static/media/search.05cc2472.svg";